import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import ExportInstallation from "./Tabs/exportTab";
import EditInstallation from "./Tabs/editTab";
import SearchJob from "./Tabs/searchTab";

export default function IssueInstallationWorkOrder() {
  const navigate = useNavigate();
  const [information, setInformation] = useState(null)
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const refreshPage = (path, state) => {
    navigate(path, { state: state });
  };

  const handleChangeTab = (key) => {
    console.log('key', key);
    console.log('state?.name', state?.name);

    if (key !== state?.name)
      navigate("/installation_work/issue", { state: { name: key } });

    handleChangeWebsiteTab({
      key: key,
      setWebsiteName,
      tabNames: {
        create: "ออกใบสั่งงานติดตั้ง",
        edit: "ข้อมูลใบสั่งงานติดตั้ง",
        data: "ใบขอเบิกงานติดตั้ง"
      }
    });
  };

  const handleSubmitForm = (data) => {
    console.log('data', data);

    // setInformation(data)
    navigate("/installation_work/issue", { state: { name: "edit", data: data } });
    navigate(0)
  }


  useEffect(() =>
    handleChangeTab(state?.name || "create")
    // handleChangeTab('edit')
    , []);


  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta
          name="description"
          content="Installation work notification Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "create"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="create" title="ออกใบสั่งงานติดตั้ง">
            {websiteName === "ออกใบสั่งงานติดตั้ง" && <ExportInstallation callback={handleSubmitForm} />}
          </Tab>
          <Tab eventKey="edit" title="ข้อมูลใบสั่งงานติดตั้ง">
            {websiteName === "ข้อมูลใบสั่งงานติดตั้ง" && <EditInstallation informationDefault={information} />}
          </Tab>
          <Tab eventKey="data" title="ใบขอเบิกงานติดตั้ง">
            {websiteName === "ใบขอเบิกงานติดตั้ง" && <SearchJob />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}

